import { NavBar } from 'components/NavBar/NavBar'
import { getActionableReports, getCompanyReports } from 'features/attendance/attendanceSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, H1WithBack, PageWrapper, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { getParams } from 'utils/helpers'
import { ActionableReports } from './ActionableReports'
import { CompanyReports } from './CompanyReports'
import { CreateReportModal } from './CreateReportModal'

export const AttendanceReports = () => {
    const [active, setActive] = useState('Actionable')
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const [createModal, setCreateModal] = useState(false)
    const dispatch = useDispatch<AppDispatch>()
    const { actionableReports, companyReports } = useSelector((state: RootState) => state.attendance)

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispatch(active == 'Actionable' ? getActionableReports(params) : getCompanyReports(params))
    }, [params])

    const handleActive = (tab: string) => {
        setParams({ page: 1, limit: 30 })
        setActive(tab)
    }



    return <><NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Attendance Reports' />
                <Button orange onClick={() => setCreateModal(true)}>
                    Create Report
                </Button>
            </Flex>
            <Flex mt='16' mb='16' gap='0.5rem ' >
                <TabsContainer>
                    <Tabs active={active === 'Actionable'} onClick={() => handleActive('Actionable')} >Actionable</Tabs>
                    <Tabs active={active === 'Company Reports'} onClick={() => handleActive('Company Reports')} >Company Reports</Tabs>
                </TabsContainer>
            </Flex>
            {active === 'Actionable' ? <ActionableReports params={params} setParams={setParams} reports={actionableReports} /> : <CompanyReports params={params} setParams={setParams} reports={companyReports} />}
        </PageWrapper>

        {createModal && <CreateReportModal closeModal={() => setCreateModal(false)} />}
    </>
}